import { IClientConfig } from "src/client-config/config";
import { ISelection } from "src/constants/interfaces/bet";
import { splitFractionalPart } from "../helpers";
import { getSystemOptionVariantsCount } from "../systemHelpers";
import { getPrice } from "../priceCalculation";

export function getSystemPossibleWin(
	config: IClientConfig,
	stake: number,
	selections: ISelection[],
	combinationCount: number
) {
	const bankers = selections.filter(item => item.isBanker);
	const remainSelections = selections.filter((item) => !item.isBanker);
	const remainCombinationCount = combinationCount - bankers.length;

	const bankersTotalOdd = bankers.reduce((acc, item) => acc * getPrice(item), 1);

	const variantsCount = getSystemOptionVariantsCount(
		remainCombinationCount,
		selections.length - bankers.length,
	);

	const stakePerBet = stake / variantsCount;

	let tempPosWin = 0;
	const indexArray = [];
	let indexMaxArray = [];
	let tempOdd;
	let tempIterator;
	let i;

	for (i = 0; i < remainCombinationCount; i++) {
		indexArray[i] = i;
		indexMaxArray[i] = remainSelections.length - i;
	}

	indexMaxArray = indexMaxArray.reverse();
	tempIterator = remainCombinationCount - 1;
	let m, j;
	while (indexArray[0] <= indexMaxArray[0]) {
		if (indexArray[tempIterator] < indexMaxArray[tempIterator]) {
			if (tempIterator !== remainCombinationCount - 1) {
				tempIterator = remainCombinationCount - 1;
				continue;
			}
			tempOdd = bankersTotalOdd;
			for (m = 0; m < remainCombinationCount; m++) {
				tempOdd *= getPrice(remainSelections[indexArray[m]]);
			}
			tempPosWin += splitFractionalPart(tempOdd * 100) / 100;
			indexArray[tempIterator]++;
		} else {
			tempIterator--;

			indexArray[tempIterator]++;

			for (j = tempIterator; j < remainCombinationCount - 1; j++) {
				indexArray[j + 1] = indexArray[j] + 1;
			}
		}
	}

	const win = +(splitFractionalPart(tempPosWin * 100 * stakePerBet) / 100).toFixed(2);
	return Math.round(win * 1000 || 0) / 1000;
}
